/**
 * Created by piotr.pozniak@thebeaverhead.com on 23/11/2023
 */

import React from "react";
import BrandLogo from "./BrandLogo";
import { useTranslation } from "react-i18next";

/**
 * Basic details form for organization management.
 * @param props
 * @param {Object} props.organization - Organization data.
 * @param {Function} props.onSetValue - Callback to set organization data.
 * @param {Boolean} props.disabled - Whether the form is disabled.
 * @param {Object} props.organizationSettings - Settings related to the organization.
 * @param {Boolean} props.isNew - Indicates if this is a new organization.
 * @returns {Element}
 * @constructor
 */
const BasicDetailsForm = (props) => {
  const organization = props.organization;
  const { t } = useTranslation();

  /**
   *
   * @param field
   * @returns {Function}
   */
  const onSetValue = (field) => (e) => {
    e.preventDefault();

    const data = { ...organization };
    data[field] = e.target.value;

    props.onSetValue(data);
  };

  const disabled = props.disabled;

  const newLabel = props.isNew ? `New ${t("Workspace")}` : "";

  return (
    <div>
      <h3 className="page-title">Basic Information</h3>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className={"col-md-2"}>
              <BrandLogo
                settings={props.organizationSettings}
                organization={organization}
              />
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label className="focus-label" htmlFor={"name"}>
                  {newLabel} Name <span className="text-danger">*</span>
                </label>
                <input
                  id={"name"}
                  className={"form-control"}
                  type="text"
                  value={organization.name}
                  disabled={disabled}
                  onChange={onSetValue("name")}
                  maxLength={64}
                  minLength={2}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetailsForm;
